import { Component, OnInit, ViewChild, inject, input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd, RouterLinkActive, RouterLink } from '@angular/router';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    imports: [MatNavList, MatListItem, RouterLinkActive, MatIcon, RouterLink]
})
export class NotificationsComponent implements OnInit {
  private router = inject(Router);

  readonly notificPanel = input(undefined);

  // Dummy notifications
  notifications = [
    {
      message: 'New contact added',
      icon: 'assignment_ind',
      time: '1 min ago',
      route: '/',
      color: 'primary',
    },
    {
      message: 'Server rebooted',
      icon: 'settings_backup_restore',
      time: '12 min ago',
      route: '/',
      color: 'warn',
    },
  ];

  ngOnInit() {
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel().close();
      }
    });
  }
  clearAll(e) {
    e.preventDefault();
    this.notifications = [];
  }
}
